import { useEffect } from "react";
import { Modal, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icons } from "../generic/iconConfig";

const sectionStyles = {
  "No changes detected": { icon: "info" },
  Invalid: { color: "danger", icon: "error" },
  Successfully: { color: "success", icon: "success" },
  // Add more mappings as needed
};

const getSectionStyle = (section) => {
  // Try to match known section types, fallback to info
  for (const key in sectionStyles) {
    if (section.trim().startsWith(key)) return sectionStyles[key];
  }
  return { color: "secondary", icon: "•" };
};

const CarrierUploadModal = ({ data, show, setShow, cancelConfirm }) => {
  const closeModal = () => {
    setShow(false);
  };

  useEffect(() => {
    if (show && data) {
      console.log(data);
    }
  }, [show, data]);

  return (
    <Container>
      <Modal
        show={show}
        onHide={closeModal}
        centered
        dialogClassName="custom-modal"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Result</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ overflowY: "auto" }} className="w-150">
          <div className="mt-4 mb-4 ps-4">
            {data && (
              <div>
                {data
                  .split(".")
                  .filter(Boolean)
                  .map((sentence, idx) => {
                    const [section, rest] = sentence.split(":");
                    if (!rest) return null;
                    const items = rest
                      .split(",")
                      .map((s) => s.trim())
                      .filter(Boolean);

                    const { icon } = getSectionStyle(section);

                    return (
                      <div key={idx} style={{ marginBottom: "1.5rem" }}>
                        <h6>
                          <span style={{ marginRight: "0.5rem" }}>
                            {icon === "info" ? (
                              <FontAwesomeIcon
                                icon={icons.info.icon}
                                color={icons.info.iconColor}
                              />
                            ) : icon === "success" ? (
                              <FontAwesomeIcon
                                icon={icons.circleCheck.icon}
                                color={icons.circleCheck.iconColor}
                              />
                            ) : icon === "error" ? (
                              <FontAwesomeIcon
                                icon={icons.discard.icon}
                                color={icons.discard.iconColor}
                              />
                            ) : (
                              icon
                            )}
                          </span>
                          {section.trim()}
                        </h6>
                        <ul style={{ margin: "0.5rem 0 0 1.5rem" }}>
                          {items.map((item, i) => (
                            <li key={i} style={{ fontSize: "1.05rem" }}>
                              {item}
                            </li>
                          ))}
                        </ul>
                        <hr style={{ margin: "1rem 0", opacity: 0.2 }} />
                      </div>
                    );
                  })}
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default CarrierUploadModal;
